import { render, staticRenderFns } from "./UserPagination.vue?vue&type=template&id=110a305e&"
import script from "./UserPagination.vue?vue&type=script&lang=js&"
export * from "./UserPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports